const EMPLOYEE_PAY_SCALES_TABLE_READY = "employeePayScales-table-ready"
const SEARCH_TEXT_STATE = "employeePayScales-table-search-text-state"
const ROWS_PER_PAGE_STATE = "employeePayScales-table-rows-per-page-state"
const PAGINATION_STATE = "employeePayScales-table-pagination-state"

const EMPLOYEE_PAY_SCALES_ID_FOR_ACTION = "employeePayScales-table-employee-pay-scales-id-for-action"

const ADD_EDIT_EMPLOYEE_PAY_SCALE_READY = "eemployeePayScales-table-add-edit-employee-pay-scales-ready"

const PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_CITY = "previous-employee-pay-scales-filter-city"

const PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_KITCHEN_ID = "previous-employee-pay-scales-filter-kitchen-id-action"

const PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_START_DATE= "previous-employee-pay-scales-filter-start-date"
const PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_END_DATE= "previous-employee-pay-scales-filter-end-date"



const initialState = {
    isEmployeePayScalesTableReady: true,
    isAddEditEmployeePayScaleReady:true,
    employeePayScales: {},
    
    employeePayScalesSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterKitchenId : "",
    previousFilterStartDate : "",
    previousFilterEndDate : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEE_PAY_SCALES_TABLE_READY:
            return Object.assign({}, state, { isEmployeePayScalesTableReady: action.payload })
        case ADD_EDIT_EMPLOYEE_PAY_SCALE_READY:
            return Object.assign({}, state, { isAddEditEmployeePayScaleReady: action.payload })


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case EMPLOYEE_PAY_SCALES_ID_FOR_ACTION:
            return Object.assign({}, state, {employeePayScalesSelectedId:action.payload})

        case PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_KITCHEN_ID:
            return Object.assign({}, state, {previousFilterKitchenId:action.payload})

        case PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})

        case PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function employeePayScalesTableReady(data) {
    return {
        type: EMPLOYEE_PAY_SCALES_TABLE_READY,
        payload: data
    }
}


export function addEditEmployeePayScaleReady(data) {
    return {
        type: ADD_EDIT_EMPLOYEE_PAY_SCALE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function employeePayScalesIdForAction(employeePayScalesId){
    return{
        type:EMPLOYEE_PAY_SCALES_ID_FOR_ACTION,
        payload:employeePayScalesId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_CITY,
        payload:filterVal
    }
}


export function previousFilterKitchenId(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_KITCHEN_ID,
        payload:filterVal
    }
}


export function previousFilterStartDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_START_DATE,
        payload:filterVal
    }
}


export function previousFilterEndDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_PAY_SCALES_FILTER_END_DATE,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Employee Pay Scales/redux/employee_pay_scales.js